import { Card, List, Switch, Typography } from 'antd';
import React, { useState } from 'react';
import ExternalResourceAvatar from '../../common/ExternalResourceAvatar';
import { ResourceItemType } from '../../../types/course';
import {
    AddLinkResource,
    RemoveComponentButton,
    UploadFileButton,
} from '../actions/componentDetailsActions';
import { useTranslation } from 'react-i18next';
import { FileOutlined, LinkOutlined } from '@ant-design/icons';
import { isTeacher } from '../../../helpers/permissions';

const { Text, Paragraph} = Typography

const ComponentLinkResources = ({ component, user }) => {
    const { t } = useTranslation();
    const linkResources = component.link_resources;
    const canEdit = isTeacher(user);

    const getActions = (resource) => {
        if (!canEdit) {
            return [];
        }
        return [
            <RemoveComponentButton component={component} resource={resource} />,
        ];
    };

    return (
        <Card
            title={t('workbench.lessons.update.externalLinks')}
            extra={canEdit ? <AddLinkResource component={component} /> : null}
            style={{ height: '100%' }}
        >
            <List
                itemLayout="horizontal"
                dataSource={linkResources}
                renderItem={(resource: ResourceItemType) => (
                    <List.Item actions={getActions(resource)} key={resource.id}>
                        <ExternalResourceAvatar
                            key={resource.id}
                            title={resource.title}
                            url={resource.url}
                            icon={<LinkOutlined />}
                            disabled={false}
                        />
                    </List.Item>
                )}
            />
        </Card>
    );
};

const ComponentFileResource = ({ component, user }) => {
    const { t } = useTranslation();
    const fileResources = component.file_resources;
    const canEdit = isTeacher(user);

    const getActions = (resource) => {
        if (!canEdit) {
            return [];
        }
        return [
            <RemoveComponentButton component={component} resource={resource} />,
        ];
    };

    return (
        <Card
            title={t('workbench.lessons.update.files')}
            extra={canEdit ? <UploadFileButton component={component} /> : null}
            style={{ height: '100%' }}
        >
            <List
                itemLayout="horizontal"
                dataSource={fileResources}
                renderItem={(resource: ResourceItemType) => (
                    <List.Item actions={getActions(resource)} key={resource.id}>
                        <ExternalResourceAvatar
                            key={resource.id}
                            title={resource.title}
                            url={resource.url}
                            icon={<FileOutlined />}
                            disabled={false}
                        />
                    </List.Item>
                )}
            />
        </Card>
    );
};

const ComponentNotebookResource = () => {
    const {t} = useTranslation()
    const [notebookOn, setNotebookOn] = useState(true)

    return (
        <Card
            title={t('workbench.lessons.notebooks.header')}
            style={{ height: '100%', width: '100%' }}
            extra={[
                // <Switch key={'notebookSwitch'} defaultChecked={false} onChange={onSwitchChange}/>,
            ]}
        >
            <Paragraph disabled={!notebookOn}>Sklonuj repozytorium Git: W nowym notatniku, w komórce kodu wpisz następującą komendę, a następnie naciśnij Shift+Enter, aby ją uruchomić. Zamień adres_repozytorium na adres URL repozytorium, które chcesz sklonować.</Paragraph>
            <Paragraph disabled={!notebookOn}>
                <pre>!git clone adres_repozytorium</pre>
            </Paragraph>
            <Paragraph disabled={!notebookOn}>
Na przykład, jeśli chcesz sklonować repozytorium o nazwie "przykladowe-repo" z GitHuba, komenda wyglądałaby tak:
            </Paragraph>
            <Paragraph disabled={!notebookOn}>
                <pre>!git clone https://github.com/nazwa_uzytkownika/przykladowe-repo.git</pre>
            </Paragraph>
            <Paragraph disabled={!notebookOn}>
            Przejdź do sklonowanego repozytorium: Po zakończeniu klonowania, możesz przejść do sklonowanego repozytorium za pomocą następującej komendy:
            </Paragraph>
            <Paragraph disabled={!notebookOn}>
                <pre>%cd nazwa_sklonowanego_repozytorium</pre>
            </Paragraph>
            <Paragraph disabled={!notebookOn}>
            Zamień nazwa_sklonowanego_repozytorium na nazwę folderu, który został utworzony po sklonowaniu repozytorium.

Zweryfikuj zawartość repozytorium: Aby sprawdzić, czy sklonowanie przebiegło pomyślnie, możesz wyświetlić zawartość repozytorium za pomocą poniższej komendy:
            </Paragraph>
            <Paragraph disabled={!notebookOn}>
                <pre>!ls</pre>
            </Paragraph>
            <Paragraph disabled={!notebookOn}>
            W ten sposób możesz sklonować dowolne repozytorium Git do Jupyter Notebook. Pamiętaj, że te instrukcje zakładają, że korzystasz z Jupyter Notebook, który umożliwia uruchamianie komend systemu Unix (takich jak git, cd, ls) bezpośrednio w komórkach notebooka za pomocą wykrzyknika (!) lub znaku procentowego (%).
            </Paragraph>
        </Card>

    )
}

export { ComponentLinkResources, ComponentFileResource, ComponentNotebookResource };
